import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PayrixRoutingModule } from './payrix-routing.module';
import { PayrixPaymentComponent } from './payrix-payment/payrix-payment.component';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PayrixPaymentNewComponent } from './payrix-payment-new/payrix-payment.component';
import { PayPalPaymentComponent } from './paypal-payment/paypal-payment.component';
import { NgxPayPalModule } from 'ngx-paypal';
import { PaymentContainerComponent } from './payment-container/payment-container.component';
import { StripePaymentComponent } from './stripe-payment/stripe-payment.component';
import { NgxStripeModule } from 'ngx-stripe';
// import { WorldnetPaymentComponent } from './worldnet-payment/worldnet-payment.component';

@NgModule({
  declarations: [
    PayrixPaymentComponent, PayrixPaymentNewComponent, PayPalPaymentComponent, PaymentContainerComponent,
    StripePaymentComponent,
    // WorldnetPaymentComponent
  ],
  imports: [
    CommonModule,
    PayrixRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPayPalModule,
    NgxStripeModule,
  ]
})
export class PayrixModule { }
